import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import { MapPin, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const serviceAreas = [
  { city: "Gulf Shores", desc: "24/7 emergency plumbing, water heaters, remodels", slug: "gulf-shores-plumber" },
  { city: "Foley", desc: "Residential and commercial plumbing services", slug: "foley-plumber" },
  { city: "Orange Beach", desc: "Condo plumbing, beach property specialists", slug: "orange-beach-plumber" },
  { city: "Fairhope", desc: "Coastal plumbing experts along Mobile Bay", slug: "fairhope-plumber" },
  { city: "Daphne", desc: "Residential plumbing installation and repair", slug: "daphne-plumber" },
  { city: "Spanish Fort", desc: "Emergency service available 24/7", slug: "spanish-fort-plumber" },
  { city: "Ono Island", desc: "Quality plumbing fixture installation", slug: "gulf-shores-plumber" },
];

export const ServiceAreaSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section className="py-24 bg-gradient-dark relative overflow-hidden noise-overlay" id="service-areas">
      <div className="container mx-auto px-4 relative z-10" ref={ref}>
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          className="text-center mb-16"
        >
          <span className="text-primary font-semibold tracking-wider uppercase text-sm">
            Where We Work
          </span>
          <h2 className="text-4xl md:text-5xl font-bold mt-4 mb-6">
            Serving All of Baldwin County
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 mb-12">
          {serviceAreas.map((area, index) => (
            <motion.div
              key={area.city}
              initial={{ opacity: 0, y: 20 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ delay: index * 0.05 }}
            >
              <Link
                to={`/${area.slug}`}
                className="group flex items-start gap-3 p-5 rounded-xl bg-card border border-border hover:border-primary/50 transition-all"
              >
                <MapPin className="h-5 w-5 text-primary mt-0.5 shrink-0" />
                <div className="flex-1">
                  <h3 className="font-semibold text-foreground group-hover:text-primary transition-colors">
                    {area.city}
                  </h3>
                  <p className="text-sm text-muted-foreground">{area.desc}</p>
                </div>
                <ArrowRight className="h-4 w-4 text-muted-foreground group-hover:text-primary group-hover:translate-x-1 transition-all mt-1" />
              </Link>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ delay: 0.4 }}
          className="max-w-4xl mx-auto"
        >
          <div className="bg-card border border-border rounded-2xl p-8 text-center">
            <p className="text-muted-foreground leading-relaxed">
              Based in Gulf Shores, Onyx Professional Plumbing serves all surrounding Baldwin County communities including Robertsdale, Loxley, Summerdale, Bay Minette, Elberta, Perdido Beach, Magnolia Springs, and Bon Secour. With Alabama License #MP-4174 led by Fischer McKenzie, we're your trusted local plumber. Whether you need an{" "}
              <Link to="/services/emergency" className="text-primary hover:underline">emergency plumber in Gulf Shores</Link>,{" "}
              <Link to="/foley-plumber" className="text-primary hover:underline">plumbing services in Foley</Link>, or{" "}
              <Link to="/orange-beach-plumber" className="text-primary hover:underline">water heater repair in Orange Beach</Link>, we're just a phone call away.
            </p>
            <Link to="/service-areas" className="inline-flex items-center gap-2 text-primary font-medium mt-4 hover:gap-3 transition-all">
              View All Service Areas <ArrowRight className="h-4 w-4" />
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
